export default function contactFormValidation() {
  const wpcf7Form = document.querySelector(".wpcf7-form");
  if (!wpcf7Form) return;

  //formタグにクラス追加
  wpcf7Form.classList.add("hide_error_message");

  // 送信または確認ボタンをクリックしたとき
  document.querySelectorAll(".wpcf7-confirm, .wpcf7-submit").forEach(function(elm){
    elm.addEventListener("click", function(){
      document.querySelector(".wpcf7-form").classList.remove("hide_error_message");
    });
  });
}
